import React, { Component } from "react";
import Loader from "./loader.js";
import Form from "./form.js";
import Error from "./error.js";
import { api, getTable } from "./helper.js";
class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      countryData: [],
      subjectData: [],
      isLoaded: false,
      error: null,
      partnerData: [],
      partnerResults: [],
    };
    this.setError = this.setError.bind(this);
  }

  componentDidMount() {
    // store offset value returned from AJAX call where records > 100
    let offset = "";

    // Return data from getTables function. tables argument passed in as an array and assigned to state in order of call
    api
      .getTables(["subjects", "countries", "partner_universities"])
      .then(([subjects, countries, partner]) => {
        // set offset value from table data so a 2nd call (>100 records can be made)
        offset = partner.data.offset;
        this.setState({
          countryData: countries.data.records.map((record) => ({
            value: record.id,
            text: record.fields["country"],
          })),
          subjectData: subjects.data.records.map((record) => ({
            value: record.id,
            text: record.fields["subject"],
          })),
          partnerData: partner.data.records,
          partnerResults: partner.data.records,
          isLoaded: true,
        });
        // retrieve 2nd batch of records by submitting offset property to partner university
        // Airtable has a 100 record limit
        return getTable("partner_universities", offset);
        //update subject state when subjectData is populated
      })
      // Merge 2nd reponse call into partnerData state
      .then((response) => {
        this.setState({
          partnerData: [...this.state.partnerData, ...response.data.records],
          partnerResults: [...this.state.partnerData, ...response.data.records],
        });
      })
      .catch((error) => {
        this.setState({
          error: error,
        });
      });
  }

  setError(error) {
    this.setState({ error });
  }

  render() {
    return (
      <div>
        {this.state.error ? (
          <Error errortext={this.state.error} />
        ) : (
          <div>
            {this.state.isLoaded ? (
              <div>
                <Form {...this.state} sendError={this.setError} />
              </div>
            ) : (
              <Loader />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js